import { defineMessages } from 'react-intl';

export default defineMessages({
  chooseAtLeast: {
    id: 'sku-customer-preview.choose-at-least',
    defaultMessage: 'Choose at least {count}',
  },
  chooseExact: {
    id: 'sku-customer-preview.choose-exact',
    defaultMessage: 'Choose {count}',
  },
  chooseRange: {
    id: 'sku-customer-preview.choose-range',
    defaultMessage: 'Choose {min}-{max}',
  },
  chooseUpTo: {
    id: 'sku-customer-preview.choose-up-to',
    defaultMessage: 'Choose up to {count}',
  },
  itemNamePlaceholder: {
    id: 'sku-customer-preview.item-name-placeholder',
    defaultMessage: 'Item name',
  },
  optionalBadge: {
    id: 'sku-customer-preview.optional-badge',
    defaultMessage: 'Optional',
  },
  optionNamePlaceholder: {
    id: 'sku-customer-preview.option-name-placeholder',
    defaultMessage: 'Option name',
  },
  requiredBadge: {
    id: 'sku-customer-preview.required-badge',
    defaultMessage: 'Required',
  },
  subheader: {
    id: 'sku-customer-preview.subheader',
    defaultMessage: 'See how your modifier will appear to customers. For illustrative purposes only.',
  },
  title: {
    id: 'sku-customer-preview.title',
    defaultMessage: 'Preview',
  },
});
